// Libs
import React, { Component } from 'react'
import { Row, Col } from '../../components/Elemental'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'

// Components/Containers
import NewInicialPageFile from './components/NewInicialPageFile'
import Breadcrumb from '../../components/Breadcrumb'
import Button from '../../components/Button'
import Form from '../../components/Form'
import Input from '../../components/Input'
import Label from '../../components/Label'
import Select from '../../components/Select'
import Warning from '../../containers/Warning'

// Imgs
import inicialImg from '../../assets/inicial.svg'
import anexosImg from '../../assets/anexos.svg'

// Normalize
import * as normalize from '../../constants/normalize'

// Options
import * as options from '../../constants/options'

// Validate
import { required, minLength14 } from '../../constants/validate'

// Actions
import { changeCities, changeCategories, fetchCities, fetchCompanies, fetchCategories } from '../App/actions'
import { createInicial } from './actions'
import { change } from 'redux-form'

class NewInicialPage extends Component {
  UNSAFE_componentWillMount() {
    const { fetchCompanies } = this.props

    fetchCompanies()
  }

  handleFormSubmit = (reduxFormData) => {
    const { user, createInicial } = this.props
    const data = { ...reduxFormData, id: user.id }

    return createInicial(data)
  }

  render() {
    const {
      localLoading,
      cities,
      companies,
      categories,
      changeCities,
      changeCategories,
      fetchCities,
      fetchCategories,
      handleSubmit } = this.props

    const selectedUf = value => options.uf.some(uf => uf.value === value) ? undefined : 'Opção Inexistente'
    const selectedCity = value => cities.some(city => city.value === value) ? undefined : 'Opção Inexistente'

    return (
      <div className="new-inicial-page">
        <Breadcrumb routes={['Inserir Caso']} />
        <Warning gutterBottom={20} />
        <Form autoComplete="off" onSubmit={handleSubmit(this.handleFormSubmit)}>
          <Row>
            <Col>
              <Label gutterTop={0}>Dados do Cliente</Label>
            </Col>
            <Col md="50%" lg="25%">
              <Field
                component={Input}
                name="clientFullName"
                label="Nome Completo"
                gutter={25}
                validate={required} />
            </Col>
            <Col md="50%" lg="25%">
              <Field
                component={Input}
                name="clientCpf"
                label="CPF"
                placeholder="000.000.000-01"
                gutter={25}
                normalize={normalize.cpf}
                validate={[required, minLength14]} />
            </Col>
            <Col md="50%" lg="25%">
              <Field
                component={Select}
                name="clientUf"
                label="Estado"
                gutter={25}
                handleSelect={option => fetchCities(option.value)}
                handleClear={() => changeCities([])}
                normalize={normalize.uf}
                options={options.uf}
                validate={[required, selectedUf]} />
            </Col>
            <Col md="50%" lg="25%">
              <Field
                component={Select}
                name="clientCity"
                label="Cidade"
                gutter={25}
                disabled={cities.length === 0 ? true : false}
                options={cities}
                validate={[required, selectedCity]} />
            </Col>
            <Col>
              <Label>Dados da Empresa</Label>
            </Col>
            <Col md="50%">
              <Field
                component={Select}
                name="companyName"
                label="Nome"
                gutter={25}
                createLabel="Adicionar Nova Empresa"
                handleCreate={() => fetchCategories()}
                handleSelect={option => fetchCategories(option.id)}
                handleClear={() => changeCategories([])}
                options={companies}
                validate={required} />
            </Col>
            <Col md="50%">
              <Field
                component={Select}
                name="companyCategory"
                label="Categoria/Segmento"
                gutter={25}
                options={categories}
                disabled={categories.length <= 1 ? true : false} />
            </Col>
            <Col>
              <Label>Documentos</Label>
            </Col>
            <Col sm="100%" md="50%">
              <Field
                component={NewInicialPageFile}
                name="file1"
                label="Petição Inicial"
                multiple={false}
                img={inicialImg}
                gutter={25}
                validate={required} />
            </Col>
            <Col sm="100%" md="50%">
              <Field
                component={NewInicialPageFile}
                name="file2"
                label="Anexos"
                multiple={true}
                img={anexosImg}
                gutter={25}
                onFileAttachLimit={this.onFileAttachLimit} />
            </Col>
          </Row>
          <Row>
            <Col sm="100%" md="50%" lg="25%">
              <Button type="submit" localLoading={localLoading} gutterTop={30}>Enviar</Button>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

NewInicialPage = reduxForm({
  form: 'newInicial',
})(NewInicialPage);

NewInicialPage = connect(state => {
  return {
    localLoading: state.app.localLoading,
    tip: state.app.tip,
    err: state.app.err,
    success: state.app.success,
    cities: state.app.cities,
    companies: state.app.companies,
    categories: state.app.categories,
    user: state.auth.user
  }
}, { changeCities, changeCategories, fetchCities, fetchCompanies, fetchCategories, createInicial, change })(NewInicialPage)

export default NewInicialPage
